import { useTranslation } from "react-i18next";
import { cartwhite, more, moreRotated } from "assets/icons";
import { notification } from "antd";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { userAddCartItemsActions } from "redux/actions/Cart/userAddCartItemsActions";
import { userGetCartItemsActions } from "redux/actions/Cart/userGetCartItemsActions";
import { ADD_TO_CART } from "redux/types";
import { useNavigate } from "react-router-dom";
import { EXTERNAL_PROJECTS_DETAILS_PATH } from "Routes/paths";

interface ExternalProjectCardProps {
  project: any;
}
interface amountType {
  amount: string;
}

const ExternalProjectCard = ({ project }: ExternalProjectCardProps) => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { t, i18n } = useTranslation();

  const { userId, loginData } = useSelector(
    (state: RootState) => state.loginReducer
  );

  //////////////////// validating the donation amount
  const formik = useFormik({
    initialValues: {
      amount: "",
    },

    validationSchema: yup.object({
      amount: yup
        .number()
        .typeError(`${t("Amount must be a number")}`)
        .positive(`${t("Amount must be greater than zero")}`)
        .required(`${t("This field is required")}`),
    }),
    onSubmit: async (values: amountType) => {
      // dispatch(
      //   requestSecureUrlActions(
      // i18n.language,
      // userId ? userId : 0,
      //     {
      //      "device_info": null,
      //       projects: {
      //         internal_projects: [
      //           {
      //             id: data?.id,
      //             amount: formik.values.amount,
      //           },
      //         ],
      //       },
      //     },
      //     (urlLink: any) => {
      //       setTimeout(() => {
      //         window.open(`${urlLink?.message}`, "_blank");
      //         // dispatch({ type: "SET_SecureUrlData" });
      //       }, 1000);
      //     }
      //   )
      // );
    },
  });

  // console.log(project);
  return (
    <div className="w-full  flex flex-col justify-between gap-2">
      {/* project image  */}
      <div className="w-full min-h-[128px] bg-blue-300">
        <img src="" alt="" />
      </div>

      {/* title  */}
      <div className="text-second_color text-[16px] font-[600] line-clamp-1 text-ellipsis">
        <p>
          {i18n.language === "en"
            ? project?.project_name_en
            : project?.project_name_ar}
        </p>
      </div>

      {/* country  */}
      <div className="text-second_color text-[14px] font-[600]">
        <p>
          {i18n.language === "en"
            ? project?.country?.name_en
            : project?.country?.name_ar}
        </p>
      </div>

      {/* description  */}
      <div
        className="max-w-[80%] text-[#444444] text-[12px] font-[500] line-clamp-2 text-ellipsis"
        dangerouslySetInnerHTML={{
          __html:
            i18n.language === "en"
              ? project?.description_en || ""
              : project?.description_ar || "",
        }}
      ></div>

      {/* price  */}
      <div className="flex items-center gap-4 text-first_color text-[24px] font-[600]">
        <p>{project?.project_cost} </p>
        <p>{t("AED")}</p>
      </div>

      {/* buttons section  */}
      <div className="w-full flex items-center gap-2">
        {/* sms donation  */}
        <button
          className={`h-[48px] w-full flex items-center justify-center bg-[#E9EBEC] text-[#263A4B] text-[15px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] rounded-[15px] hover:bg-[#e4cdb4] duration-300`}
        >
          {t("Donate")}
        </button>

        {/* cart button  */}
        <button
          className={`h-[48px] w-[120px] flex items-center justify-center bg-[#B07F4A] text-[#ffffff] text-[15px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] rounded-[15px] hover:bg-[#614629] duration-300`}
          // onClick={() => {
          //   if (formik.values.amount) {
          //     loginData
          //       ? dispatch(
          //           userAddCartItemsActions(
          // i18n.language,
          // userId,
          //             {
          //               user_id: userId,
          //               device: "web",
          //               project_type: "charity_project",
          //               id: data?.id,
          //               duration: 0,
          //               amount: formik.values.amount,
          //             },
          // () => {
          //   dispatch(userGetCartItemsActions(userId, i18n.language));
          // }
          //           )
          //         )
          //       : dispatch(
          //           {
          //             type: ADD_TO_CART,
          //             payload: {
          //               category: "internal_projects",
          //               project: {
          //                 id: data?.id,
          //                 amount: formik.values.amount,
          //                 image_url: data?.image_url,
          //                 title_en: data?.title_en,
          //                 title_ar: data?.title_ar,
          //                 duration: 0,
          //                 project_type: "charity_project",
          //                 device: "web",
          //               },
          //             },
          //           },
          //           notification.success({
          //             message: "Added to cart",
          //           })
          //         );
          //   } else {
          //     notification.error({
          //       message: `${t("Donation amount is required")}`,
          //     });
          //   }
          // }}
        >
          <img className="min-w-[30px]" src={cartwhite} alt="" />
        </button>
      </div>

      {/* project details  */}
      <div>
        <p
          onClick={() =>
            navigate(`${EXTERNAL_PROJECTS_DETAILS_PATH}/${project?.project_id}`)
          }
          className={`flex items-center gap-3 font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600] text-[18px] text-first_color cursor-pointer group`}
        >
          {t("Project Details")}
          {i18n.language === "en" ? (
            <img
              className="group-hover:animate-[moveRight_1s_ease-in-out_infinite]"
              src={more}
              alt=""
            />
          ) : (
            <img
              className="group-hover:animate-[moveLeft_1s_ease-in-out_infinite]"
              src={moreRotated}
              alt=""
            />
          )}
        </p>
      </div>
    </div>
  );
};

export default ExternalProjectCard;
